/**
 * Health Integration Icons
 *
 * Icons used in the Apple Health / Health Connect integration screens
 * and health data category displays.
 */

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faHeartPulse as fadHeartPulse,
  faRotate as fadRotate,
  faPersonRunning as fadPersonRunning,
  faWeightScale as fadWeightScale,
  faAppleWhole as fadAppleWhole,
  // Activity types
  faShoePrints as fadShoePrints,
  faFireFlameCurved as fadFireFlameCurved,
  faStopwatch as fadStopwatch,
  faStairs as fadStairs,
  // Vitals types
  faHeart as fadHeart,
  faDroplet as fadDroplet,
  faLungs as fadLungs,
  faTemperatureHalf as fadTemperatureHalf,
  // Body types
  faChartSimple as fadChartSimple,
  faRulerVertical as fadRulerVertical,
  faPerson as fadPerson,
  faDumbbell as fadDumbbell,
  // Nutrition types
  faUtensils as fadUtensils,
  faDrumstickBite as fadDrumstickBite,
  faBreadSlice as fadBreadSlice,
  faGlassWater as fadGlassWater,
  faMessageMedical as fadMessageMedical,
  faHandHoldingHeart as fadHandHoldingHeart,
  faIdCard as fadIdCard,
  faLandmarkFlag as fadLandmarkFlag,
  faLocationDot as fadLocationDot,
  faWatchApple as fadWatchApple,
  faForkKnife as fadForkKnife,
  // Mobility types
  faPersonWalking as fadPersonWalking,
  faGauge as fadGauge,
  // Wellness signals (status hero + check-now; was referenced unregistered,
  // which rendered a silent blank on the check-now button)
  faWavePulse as fadWavePulse,
  // Mind & Environment types
  faBrain as fadBrain,
  faSun as fadSun,
  faFacePensive as fadFacePensive,
  faHeadSideBrain as fadHeadSideBrain,
  // Clinical types
  faSyringe as fadSyringe,
  faFileHeart as fadFileHeart,
  faNoteMedical as fadNoteMedical,
  faNotesMedical as fadNotesMedical,
  // Health profile findings (ED-2665)
  faDisease as fadDisease,
  faDna as fadDna,
} from '@fortawesome/pro-duotone-svg-icons';

import { faLockOpen as fasLockOpen, faHeartPulse as fasHeartPulse, faPills as fasPills, faLocationDot as fasLocationDot, faPrescriptionBottleMedical as fasPrescriptionBottleMedical } from '@fortawesome/pro-solid-svg-icons';

export const loadHealthIcons = () => {
  library.add(
    // Category icons
    fadHeartPulse,
    fadRotate,
    fadPersonRunning,
    fadWeightScale,
    fadAppleWhole,
    // Activity type icons
    fadShoePrints,
    fadFireFlameCurved,
    fadStopwatch,
    fadStairs,
    // Vitals type icons
    fadHeart,
    fadDroplet,
    fadLungs,
    fadTemperatureHalf,
    // Body type icons
    fadChartSimple,
    fadRulerVertical,
    fadPerson,
    fadDumbbell,
    // Nutrition type icons
    fadUtensils,
    fadDrumstickBite,
    fadBreadSlice,
    fadGlassWater,
    // Mobility type icons
    fadPersonWalking,
    fadGauge,
    // Wellness signal icons
    fadWavePulse,
    // Mind & Environment type icons
    fadBrain,
    fadSun,
    fadFacePensive,
    fadHeadSideBrain,
    // Clinical type icons
    fadSyringe,
    // Solid
    fasHeartPulse,
    fasPills,
    fadMessageMedical,
    fasPrescriptionBottleMedical,
    fadHandHoldingHeart,
    fadIdCard,
    fadLandmarkFlag,
    fadLocationDot,
    fasLocationDot,
    fadWatchApple,
    fadForkKnife,
    fadFileHeart,
    fasLockOpen,
    fadNoteMedical,
    fadNotesMedical,
    fadDisease,
    fadDna
  );
};
